<template>
  <div class="text-white min-h-screen relative">
    <NuxtPage />
    <LoaderFull />
    <music-player/>
  </div>
</template>

